var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "app_markdown_display",
    style: {
      fontSize: _vm.fontSize,
      width: _vm.width
    }
  }, [_vm.markdown ? _c('div', {
    directives: [{
      name: "safe-html",
      rawName: "v-safe-html",
      value: _vm.htmlFromMarkdown,
      expression: "htmlFromMarkdown"
    }],
    ref: "markdown__body",
    staticClass: "markdown__body",
    staticStyle: {
      "font-size": "16px"
    }
  }) : _c('div', {
    staticClass: "markdown__no_result"
  }, [_vm._v(" " + _vm._s(_vm.noMarkdownText) + " ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };